import axios from "axios";
import "@libs/axios";
import type { AxiosRequestConfig } from "axios";

let countLimit = 0;

function isRequestLimitExceeded() {
  return countLimit > window.appConfig.requestLimitPerSecond;
}

function increaseRequestCount() {
  countLimit += 1;

  setTimeout(() => {
    countLimit -= 1;
  }, 1000);
}

export class ServiceBase {
  baseUrl: string;

  constructor() {
    this.baseUrl = window.appConfig.baseUrl ?? "";
  }

  private getUrl = (url: string) => `${this.baseUrl}${url}`;

  sendGet = async (url: string, abortController?: AbortController, config?: AxiosRequestConfig) => {
    if (isRequestLimitExceeded()) {
      console.error("Request limit exceeded");
      return null;
    }

    increaseRequestCount();

    let axiosConfig = config;

    if (abortController) {
      axiosConfig = { ...config, signal: abortController.signal };
    }

    const response = await axios.get(this.getUrl(url), axiosConfig);
    return response?.data;
  };

  sendPost = async (url: string, params: any, abortController?: AbortController, config?: AxiosRequestConfig) => {
    let axiosConfig = config;

    if (abortController) {
      axiosConfig = { ...config, signal: abortController.signal };
    }

    const response = await axios.post(this.getUrl(url), params, axiosConfig);
    return response?.data;
  };

  sendPut = async (url: string, params: any, abortController?: AbortController, config?: AxiosRequestConfig) => {
    let axiosConfig = config;

    if (abortController) {
      axiosConfig = { ...config, signal: abortController.signal };
    }

    const response = await axios.put(this.getUrl(url), params, axiosConfig);
    return response?.data;
  };

  sendDelete = async (url: string, abortController?: AbortController, config?: AxiosRequestConfig) => {
    let axiosConfig = config;

    if (abortController) {
      axiosConfig = { ...config, signal: abortController.signal };
    }

    const response = await axios.delete(this.getUrl(url), axiosConfig);
    return response?.data;
  };

  sendPatch = async (url: string, params: any, abortController?: AbortController, config?: AxiosRequestConfig) => {
    let axiosConfig = config;

    if (abortController) {
      axiosConfig = { ...config, signal: abortController.signal };
    }

    const response = await axios.patch(this.getUrl(url), params, axiosConfig);
    return response;
  };
}
